import React, { useState, useEffect } from "react";
import CbImg from "./CbImg";
import SummaryItemDetails from "./SummaryItemDetails";
import "../styles/basket.css";

const SummaryItemTils = (props) => {
  const itemId = props.item?.item_id ?? props.id ?? "unknown";

  return (
    <div className="summary_item_container" data-testid={`summary-item-${itemId}`}>
      <div className="basket_item">
        <div
          className="relative flex items-center justify-center overflow-hidden w-basket-img-sm h-basket-img-sm md:w-basket-img-lg md:h-basket-img-lg"
          style={{
            flexShrink: 0,
          }}
          data-testid={`summary-item-image-${itemId}`}
        >
          <CbImg
            isTile={true}
            setSelectedValue={props.setSelectedValue}
            item={props.item}
            hasCheckbox={"none"}
            frameClasses={"basket_item"}
          ></CbImg>
        </div>
        <div style={{ flexGrow: 1 }} data-testid={`summary-item-details-wrapper-${itemId}`}>
          <SummaryItemDetails
            couponsItem={props.couponsItem}
          ></SummaryItemDetails>
        </div>
      </div>
    </div>
  );
};
export default SummaryItemTils;
